import { ListarComodosService } from "../../../../Services/AssistenciaTecnica/Atendimento/Comodos/ComodosAssistencia";
import { Controller } from "../../../Controller";

export async function ListarComodosController() {
    return Controller(ListarComodosService());
}
